import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";

export const LOAN_PAYMENT_FREQUENCIES = [
	ClientPortfolioPaymentFrequencyEnum.Monthly,
	ClientPortfolioPaymentFrequencyEnum.Quarterly,
	ClientPortfolioPaymentFrequencyEnum.Semiannually,
	ClientPortfolioPaymentFrequencyEnum.Yearly,
];

export const toLoanPaymentFrequency = (
	frequency: ClientPortfolioPaymentFrequencyEnum | null | undefined,
): ClientPortfolioPaymentFrequencyEnum | null => {
	if (!frequency) {
		return ClientPortfolioPaymentFrequencyEnum.Monthly;
	}

	return LOAN_PAYMENT_FREQUENCIES.includes(frequency) ? frequency : null;
};
